import LoginGoogle from "./GoogleLogin";
import LoginFacebook from "./FacebookLogin";

const SSO = {
    LoginGoogle,
    LoginFacebook
}

export default SSO;
